// Introduction
import AboutHawkClient, { markdownContent as AboutHawkClientMarkdown }
    from './components/Introduction/AboutHawkClient.Component';

// Getting Started
import Download, { markdownContent as DownloadMarkdown }
    from './components/GettingStarted/Download.Component';
import CreateWorkspace, { markdownContent as CreateWorkspaceMarkdown }
    from './components/GettingStarted/CreateWorkspace.Component';
import CreateCollection, { markdownContent as CreateCollectionMarkdown }
    from './components/GettingStarted/CreateCollection.Component';
import CreateRequest, { markdownContent as CreateRequestMarkdown }
    from './components/GettingStarted/CreateRequest.Component';

// Variables
import VariablesOverview, { markdownContent as VariablesOverviewMarkdown }
    from './components/Variables/Overview.Component';
import RequestVariables, { markdownContent as RequestVariablesMarkdown }
    from './components/Variables/RequestVariables.Component';
import CollectionVariables, { markdownContent as CollectionVariablesMarkdown }
    from './components/Variables/CollectionVariables.Component';
import EnvVariables, { markdownContent as EnvVariablesMarkdown }
    from './components/Variables/EnvVariables.Component';
import GlobalVariables, { markdownContent as GlobalVariablesMarkdown }
    from './components/Variables/GlobalVariables.Component';

// Send Request
import OverviewTab, { markdownContent as SendRequestOverviewMarkdown }
    from './components/SendRequest/REST/Overview.Component';
import HeadersTab, { markdownContent as HeadersMarkdown }
    from './components/SendRequest/REST/Headers.Component';
import BodyTab, { markdownContent as BodyMarkdown }
    from './components/SendRequest/REST/Body.Component';
import QueryParamsTab, { markdownContent as QueryParamsMarkdown }
    from './components/SendRequest/REST/Params.Component';
// grpc
import GRPCOverview, { markdownContent as GRPCOverviewMarkdown } from './components/SendRequest/GRPC/Overview.Component';
import GRPCInterfaceWalkthrough, { markdownContent as GRPCInterfaceWalkthroughMarkdown } from './components/SendRequest/GRPC/InterfaceWalkthrough.Component';
import GRPCServiceDefinition, { markdownContent as GRPCServiceDefinitionMarkdown } from './components/SendRequest/GRPC/GRPCServiceDefinition.Component';
import GRPCMetadataTab, { markdownContent as GRPCMetadataTabMarkdown } from './components/SendRequest/GRPC/GRPCMetadataTab.Component';
import GRPCMessageTab, { markdownContent as GRPCMessageTabMarkdown } from './components/SendRequest/GRPC/GRPCMessageTab.Component';
import GRPCResponsePanel, { markdownContent as GRPCResponsePanelMarkdown } from './components/SendRequest/GRPC/GRPCResponsePanel.Component';

// Validations
import Validations, { markdownContent as ValidationsMarkdown }
    from './components/ValidationsDoc/Validations.Component';

// Scripting
import ScriptOverview, { markdownContent as ScriptOverviewMarkdown }
    from './components/ScriptDoc/ScriptOverview.Component';
import ScriptDoc, { markdownContent as ScriptDocMarkdown }
    from './components/ScriptDoc/ScriptDoc.Component';
import JSFile, { markdownContent as JSFileMarkdown }
    from './components/ScriptDoc/JSFile.Component';
import ExternalNodeModules, { markdownContent as ExternalNodeModulesMarkdown }
    from './components/ScriptDoc/ExternalNodeModules.Component';
import InbuiltNodeModules, { markdownContent as InbuiltNodeModulesMarkdown }
    from './components/ScriptDoc/InbuiltNodeModules.Component';
import ScriptSequence, { markdownContent as ScriptSequenceMarkdown } from './components/ScriptDoc/ScriptSequence.Component';

// API Flows
import FlowsDoc, { markdownContent as FlowsOverviewMarkdown }
    from './components/FlowsDoc/FlowsDoc.Component';
import ForLoop, { markdownContent as ForLoopMarkdown }
    from './components/FlowsDoc/ForLoop.Component';
import IfCondition, { markdownContent as IfConditionMarkdown }
    from './components/FlowsDoc/IfCondition.Component';

// Document APIs
import APIDocumentationOverview, { markdownContent as APIDocumentationOverviewMarkdown }
    from './components/APIsDocumentation/Overview.Component';
import CollectionDocumentation, { markdownContent as CollectionDocumentationMarkdown }
    from './components/APIsDocumentation/CollectionDocumentation.Component';
import RequestDocumentation, { markdownContent as RequestDocumentationMarkdown }
    from './components/APIsDocumentation/RequestDocumentation.Component';
import FolderDocumentation, { markdownContent as FolderDocumentationMarkdown } from './components/APIsDocumentation/FolderDocumentation.Component';

// OpenAPI
import OpenAPIOverview, { markdownContent as OpenAPIOverviewMarkdown }
    from './components/SwaggerDoc/SwaggerDoc.Component';

// CLI
import HawkClientCLIInstructions, { markdownContent as HawkClientCLIMarkdown }
    from './components/CLIDoc/CLIDoc.Component';


export const docsRoutes = [
    {
        id: "Introduction",
        label: 'Introduction',
        children: [
            {
                id: "Introduction:About HawkClient",
                label: 'About HawkClient',
                path: 'introduction/about',
                component: AboutHawkClient,
                content: AboutHawkClientMarkdown,
            },
        ],
    },
    {
        id: "Getting Started",
        label: 'Getting Started',
        children: [
            { id: "Getting Started:Download", label: 'Download', path: 'getting-started/download', component: Download, content: DownloadMarkdown },
            { id: "Getting Started:Create Workspace", label: 'Create Workspace', path: 'getting-started/workspace', component: CreateWorkspace, content: CreateWorkspaceMarkdown },
            { id: "Getting Started:Create Collection", label: 'Create Collection', path: 'getting-started/collection', component: CreateCollection, content: CreateCollectionMarkdown },
            { id: "Getting Started:Create Request", label: 'Create Request', path: 'getting-started/request', component: CreateRequest, content: CreateRequestMarkdown },
        ],
    },
    {
        id: "Variables",
        label: 'Variables',
        children: [
            { id: "Variables:Overview", label: 'Overview', path: 'variables/overview', component: VariablesOverview, content: VariablesOverviewMarkdown },
            { id: "Variables:Request Variables", label: 'Request Variables', path: 'variables/request', component: RequestVariables, content: RequestVariablesMarkdown },
            { id: "Variables:Collection Variables", label: 'Collection Variables', path: 'variables/collection', component: CollectionVariables, content: CollectionVariablesMarkdown },
            { id: "Variables:Environment Variables", label: 'Environment Variables', path: 'variables/environment', component: EnvVariables, content: EnvVariablesMarkdown },
            { id: "Variables:Global Variables", label: 'Global Variables', path: 'variables/global', component: GlobalVariables, content: GlobalVariablesMarkdown },
        ],
    },
    {
        id: "Send Request",
        label: 'Send Request',
        children: [
            {
                id: "Send Request:REST",
                label: 'REST',
                children: [
                    { id: "Send Request:REST:Overview", label: 'Overview', path: 'send-request/rest/overview', component: OverviewTab, content: SendRequestOverviewMarkdown },
                    { id: "Send Request:REST:Headers", label: 'Headers', path: 'send-request/rest/headers', component: HeadersTab, content: HeadersMarkdown },
                    { id: "Send Request:REST:Body", label: 'Body', path: 'send-request/rest/body', component: BodyTab, content: BodyMarkdown },
                    { id: "Send Request:REST:Params", label: 'Params', path: 'send-request/rest/params', component: QueryParamsTab, content: QueryParamsMarkdown },
                ]
            },
            {
                id: "Send Request:GRPC",
                label: 'GRPC',
                children: [
                    { id: "Send Request:GRPC:Overview", label: 'Overview', path: 'send-request/grpc/overview', component: GRPCOverview, content: GRPCOverviewMarkdown },
                    { id: "Send Request:GRPC:InterfaceWalkthrough", label: 'Interface Walkthrough', path: 'send-request/grpc/interface-walkthrough', component: GRPCInterfaceWalkthrough, content: GRPCInterfaceWalkthroughMarkdown },
                    { id: "Send Request:GRPC:GRPCServiceDefinition", label: 'Service Definition', path: 'send-request/grpc/service-definition', component: GRPCServiceDefinition, content: GRPCServiceDefinitionMarkdown },
                    { id: "Send Request:GRPC:GRPCMetadataTab", label: 'Metadata Tab', path: 'send-request/grpc/metadata', component: GRPCMetadataTab, content: GRPCMetadataTabMarkdown },
                    { id: "Send Request:GRPC:GRPCMessageTab", label: 'Message Tab', path: 'send-request/grpc/message-tab', component: GRPCMessageTab, content: GRPCMessageTabMarkdown },
                    { id: "Send Request:GRPC:GRPCResponsePanel", label: 'Response Panel', path: 'send-request/grpc/response-pannel', component: GRPCResponsePanel, content: GRPCResponsePanelMarkdown },

                ]
            }
        ],
    },
    {
        id: "Validations",
        label: 'Validations',
        children: [
            { id: "Validations:Validations", label: 'Validations', path: 'validations', component: Validations, content: ValidationsMarkdown },
        ],
    },
    {
        id: "Scripting",
        label: 'Scripting',
        children: [
            { id: "Scripting:Overview", label: 'Overview', path: 'scripting/overview', component: ScriptOverview, content: ScriptOverviewMarkdown },
            { id: "Scripting:ScriptSequence", label: 'Script Sequence', path: 'scripting/script-sequence', component: ScriptSequence, content: ScriptSequenceMarkdown },
            { id: "Scripting:Script Functions", label: 'Script Functions', path: 'scripting/functions', component: ScriptDoc, content: ScriptDocMarkdown },
            { id: "Scripting:JS File", label: 'JS File', path: 'scripting/js-file', component: JSFile, content: JSFileMarkdown },
            { id: "Scripting:External Node Modules", label: 'External Node Modules', path: 'scripting/external-modules', component: ExternalNodeModules, content: ExternalNodeModulesMarkdown },
            { id: "Scripting:Inbuilt Node Modules", label: 'Inbuilt Node Modules', path: 'scripting/inbuilt-modules', component: InbuiltNodeModules, content: InbuiltNodeModulesMarkdown },
        ],
    },
    {
        id: "API Flows",
        label: 'API Flows',
        children: [
            { id: "API Flows:Overview", label: 'Overview', path: 'api-flows/overview', component: FlowsDoc, content: FlowsOverviewMarkdown },
            { id: "API Flows:For Loop", label: 'For Loop', path: 'api-flows/for-loop', component: ForLoop, content: ForLoopMarkdown },
            { id: "API Flows:If Condition", label: 'If Condition', path: 'api-flows/if-condition', component: IfCondition, content: IfConditionMarkdown },
        ],
    },
    {
        id: "Document APIs",
        label: 'Document APIs',
        children: [
            { id: "Document APIs:Overview", label: 'Overview', path: 'document-apis/overview', component: APIDocumentationOverview, content: APIDocumentationOverviewMarkdown },
            { id: "Document APIs:Collection", label: 'Collection Documentation', path: 'document-apis/collection', component: CollectionDocumentation, content: CollectionDocumentationMarkdown },
            { id: "Document APIs:Folder", label: 'Folder Documentation', path: 'document-apis/folder', component: FolderDocumentation, content: FolderDocumentationMarkdown },
            { id: "Document APIs:API Request", label: 'API Request Documentation', path: 'document-apis/request', component: RequestDocumentation, content: RequestDocumentationMarkdown },
        ],
    },
    {
        id: "OpenAPI Specs",
        label: 'OpenAPI Specs',
        children: [
            { id: "OpenAPI Specs:Overview", label: 'Overview', path: 'openapi/overview', component: OpenAPIOverview, content: OpenAPIOverviewMarkdown },
        ],
    },
    {
        id: "HawkClient CLI",
        label: 'HawkClient CLI',
        children: [
            { id: "HawkClient CLI:Overview", label: 'Overview', path: 'cli/overview', component: HawkClientCLIInstructions, content: HawkClientCLIMarkdown },
        ],
    },
];
